import { convertToHiragana } from './consts';
import { FetchCitiesByPrefectureReturnType } from './types';
import { fetchCitiesByPrefectureExecute } from './execute';

export const fetchCitiesByPrefecture = async (prefectureId: number): Promise<FetchCitiesByPrefectureReturnType> => {
  // リクエストパラメータを作成
  const searchParams = new URLSearchParams({ id: String(prefectureId) });

  // 市区町村API接続
  const { response, citiesData, errorResponse } = await fetchCitiesByPrefectureExecute(searchParams);
  const isSuccess = !!citiesData && citiesData.length > 0;
  const citiesGroupedByKana = [];

  if (isSuccess) {
    // ヨミガナの配列を作成、重複を削除して返却値の配列に値を格納
    const kanaList = [];
    citiesData.forEach((city) => {
      kanaList.push(city.yomi.slice(0, 1));
    });
    kanaList
      .filter((x, i) => kanaList.indexOf(x) === i)
      .forEach((kana) => {
        citiesGroupedByKana.push({ kana: convertToHiragana(kana), cities: [] });
      });

    // ヨミガナの配列から先頭文字を判定し新たな配列を作成
    citiesGroupedByKana.forEach((item) => {
      citiesData.forEach((city) => {
        if (item.kana === convertToHiragana(city.yomi.slice(0, 1))) {
          item.cities.push(city);
        }
      });
    });
  }

  return {
    // API接続関連
    response,
    citiesData,
    errorResponse,

    // API接続成功フラグ
    isSuccess,

    // カナごとにグルーピングした市区町村データ
    citiesGroupedByKana,
  };
};
